<osapp-header [title]="title" [hasSyncButton]="true"></osapp-header>

<ion-content>
	<calao-changelogs [url]="url | urlSanitizer" [hideLoader]="true"></calao-changelogs>
</ion-content>